module.exports = __webpack_public_path__ + "static/img/vivo3.902cd86.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/vivo/vivo3.png
// module id = 5zxc
// module chunks = 0